import React from 'react'
import { Chart as ChartJS } from "chart.js";
import { Bar } from 'react-chartjs-2'

ChartJS.register();

const formatChartData = (chartData) => {
    const labels = chartData.labels;
    const contributionDistributionPortfolio = chartData.contributionDistributionPortfolio;
    const contributionDistributions = chartData.contributionDistributions;

    const data = {
        labels,
        datasets: [
            {
                label: 'Account Value',
                data: contributionDistributionPortfolio,
                backgroundColor: ['#e9ecef'],
                stack: '1',
            },
            {
                label: 'Contributions+Distributions',
                data: contributionDistributions,
                backgroundColor: ['#212529'],
                stack: '1',
            }
        ],
    }

    return data;
}

const PotentialChart = ({data}) => {

    const barChartStyle = {
        display: 'flex', 
        flex: '1 1 auto', 
        height: '100%', 
        width: '100%',
        boxShadow: '0 .5rem 1rem rgba(0, 0, 0, .15)',
        padding: '32px',
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
              position: 'bottom',  // Ensure labels are positioned at the bottom
              beginAtZero: true,
              grid: {
                display: false
              }
            },
            y: {
              beginAtZero: true,
            },
        },
        animation: false,
        plugins: {
            legend: {
                position: 'bottom',
            },
            tooltip: {
                callbacks: {
                  label: function (context) {
                    let value = context.raw; // Get the raw value
                    return `$${Math.trunc(value).toLocaleString()}`; // Format with dollar sign and commas
                  },
                },
            }
        }
    }

    if(!data) return null;

    const chartData = formatChartData(data);

    return (
        <div style={barChartStyle}>
            <Bar data={chartData} options={options} />
        </div>
    )
}

export default PotentialChart